module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 8.a60ee6e7.png";